import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';

@Component({
  selector: 'app-hero',
  standalone: true,
  imports: [CommonModule],
  template: `
    <section class="relative min-h-screen flex items-center overflow-hidden">
      <!-- Background -->
      <div class="absolute inset-0 z-0">
        <img src="https://images.unsplash.com/photo-1534438327276-14e5300c3a48?w=1920&q=80"
             alt="Sports Gym Background"
             class="w-full h-full object-cover"/>
        <div class="hero-overlay absolute inset-0"></div>
      </div>

      <!-- Animated shapes -->
      <div class="absolute top-20 right-20 w-32 h-32 bg-primary/20 rounded-full blur-3xl animate-pulse"></div>
      <div class="absolute bottom-20 left-20 w-40 h-40 bg-accent/20 rounded-full blur-3xl animate-pulse" style="animation-delay: 1s"></div>

      <!-- Content -->
      <div class="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full pt-20">
        <div class="grid lg:grid-cols-2 gap-8 lg:gap-12 items-center">
          <!-- Text -->
          <div class="space-y-6 lg:space-y-8">
            <div class="fade-in-left inline-flex items-center gap-2 bg-primary/20 backdrop-blur-sm border border-primary/30 rounded-full px-4 py-2">
              <svg class="w-4 h-4 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17.657 18.657A8 8 0 016.343 7.343S7 9 9 10c0-2 .5-5 2.986-7C14 5 16.09 5.777 17.656 7.343A7.975 7.975 0 0120 13a7.975 7.975 0 01-2.343 5.657z"/>
              </svg>
              <span class="text-sm font-medium text-primary-foreground">بهترین باشگاه ورزشی شهر</span>
            </div>

            <h1 class="fade-in-left text-4xl sm:text-5xl lg:text-7xl font-black leading-tight text-white" style="animation-delay: 0.15s">
              باشگاه ورزشی
              <br/>
              <span class="text-primary">پارس فیتنس</span>
            </h1>

            <p class="fade-in-left text-base sm:text-lg lg:text-xl text-gray-200 max-w-lg leading-relaxed" style="animation-delay: 0.3s">
              با بیش از ۱۵ سال تجربه در زمینه آموزش ورزشی، ما با مجهز‌ترین سالن‌ها و مربیان حرفه‌ای، مسیر رسیدن به اهداف ورزشی شما را هموار می‌کنیم.
            </p>

            <div class="fade-in-left flex flex-wrap gap-4" style="animation-delay: 0.45s">
              <button (click)="navigateTo('classes')"
                      class="pulse-glow bg-primary hover:bg-primary/90 text-primary-foreground px-8 py-6 text-base font-bold rounded-xl flex items-center gap-2 transition-colors">
                <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 12h1m2 0h14M6 12a2 2 0 11-4 0 2 2 0 014 0zm12 0a2 2 0 11-4 0 2 2 0 014 0zM9 8h2m2 8h2"/>
                </svg>
                مشاهده دوره‌ها
              </button>
              <button (click)="navigateTo('contact')"
                      class="border border-white/30 text-white hover:bg-white/10 backdrop-blur-sm px-8 py-6 text-base font-bold rounded-xl flex items-center gap-2 transition-colors">
                <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"/>
                </svg>
                تماس با ما
              </button>
            </div>

            <!-- Stats -->
            <div class="fade-in-left flex flex-wrap gap-6 pt-4" style="animation-delay: 0.6s">
              <div class="flex items-center gap-2">
                <div class="w-10 h-10 rounded-lg bg-primary/20 flex items-center justify-center">
                  <svg class="w-5 h-5 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0z"/>
                  </svg>
                </div>
                <div>
                  <div class="text-xl font-bold text-white">+۲۵۰۰</div>
                  <div class="text-xs text-gray-400">عضو فعال</div>
                </div>
              </div>
              <div class="flex items-center gap-2">
                <div class="w-10 h-10 rounded-lg bg-primary/20 flex items-center justify-center">
                  <svg class="w-5 h-5 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z"/>
                  </svg>
                </div>
                <div>
                  <div class="text-xl font-bold text-white">+۱۵۰</div>
                  <div class="text-xs text-gray-400">افتخار</div>
                </div>
              </div>
              <div class="flex items-center gap-2">
                <div class="w-10 h-10 rounded-lg bg-primary/20 flex items-center justify-center">
                  <svg class="w-5 h-5 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 00-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 00-1.176 0l-3.976 2.888c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 00-.363-1.118l-3.976-2.888c-.784-.57-.38-1.81.588-1.81h4.914a1 1 0 00.951-.69l1.519-4.674z"/>
                  </svg>
                </div>
                <div>
                  <div class="text-xl font-bold text-white">۴.۹</div>
                  <div class="text-xs text-gray-400">امتیاز</div>
                </div>
              </div>
            </div>
          </div>

          <!-- Feature cards -->
          <div class="hidden lg:grid grid-cols-2 gap-4 stagger-children">
            <div *ngFor="let feature of features" class="backdrop-blur-md bg-white/10 border border-white/20 rounded-2xl p-6 hover:bg-white/15 transition-all">
              <div class="w-12 h-12 rounded-xl flex items-center justify-center mb-4" [ngClass]="feature.bg">
                <span [innerHTML]="feature.iconHtml" class="w-6 h-6"></span>
              </div>
              <h3 class="text-white font-bold text-lg mb-1">{{ feature.title }}</h3>
              <p class="text-gray-300 text-sm">{{ feature.desc }}</p>
            </div>
          </div>
        </div>
      </div>

      <!-- Scroll indicator -->
      <div class="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <div class="w-8 h-12 rounded-full border-2 border-white/30 flex items-start justify-center p-2">
          <div class="w-1.5 h-3 bg-white/60 rounded-full animate-bounce"></div>
        </div>
      </div>
    </section>
  `,
  styles: [':host { display: block; }']
})
export class HeroComponent {
  features = [
    {
      title: 'تجهیزات مدرن',
      desc: 'بهترین تجهیزات ورزشی دنیا',
      bg: 'bg-red-500/20',
      iconHtml: '<svg class="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 12h1m2 0h14M6 12a2 2 0 11-4 0 2 2 0 014 0zm12 0a2 2 0 11-4 0 2 2 0 014 0zM9 8h2m2 8h2"/></svg>'
    },
    {
      title: 'مربیان حرفه‌ای',
      desc: 'با مدارک بین‌المللی',
      bg: 'bg-orange-500/20',
      iconHtml: '<svg class="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0z"/></svg>'
    },
    {
      title: 'ساعات کاری منعطف',
      desc: 'از ۶ صبح تا ۱۲ شب',
      bg: 'bg-amber-500/20',
      iconHtml: '<svg class="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"/></svg>'
    },
    {
      title: 'دسترسی آسان',
      desc: 'مرکز شهر، پارکینگ رایگان',
      bg: 'bg-yellow-500/20',
      iconHtml: '<svg class="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"/><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"/></svg>'
    },
  ];

  constructor(private router: Router) {}

  navigateTo(path: string): void {
    this.router.navigate([path]);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
}
